import Entities from 'STORE';

export function handleSoftUpdate(property) {
  const hasSoftUpdate = Boolean(property) && property.value === 'true';

  if (hasSoftUpdate) {
    Entities.authStore.setSoftUpdate(true);
  }
}
